import React from "react";

interface Props {
	color?: "grey" | "original";
};

export const ZoomSvg: React.FC<Props> = ({ color = "original" }: Props) => {
	if (color === "original") {
		return (
			<svg
				width={20}
				height={20}
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M9.99985 17.5C14.1422 17.5 17.5 14.1419 17.5 9.99985C17.5 5.85781 14.1422 2.5 9.99985 2.5C5.85751 2.5 2.5 5.85781 2.5 9.99985C2.5 14.1419 5.85781 17.5 9.99985 17.5Z"
					fill="#2196F3"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.90112 12.143H11.8615V8.50574C11.8615 7.95775 11.4174 7.51367 10.8694 7.51367H5.90906V11.151C5.90906 11.6989 6.35313 12.143 6.90112 12.143ZM12.5225 10.8206L14.5067 12.143V7.51367L12.5228 8.83643L12.5225 10.8206Z"
					fill="white"
				/>
			</svg>
		);
	}

	return (
		<svg
			width={16}
			height={16}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.99988 14C11.3138 14 14 11.3135 14 7.99988C14 4.68625 11.3138 2 7.99988 2C4.68601 2 2 4.68625 2 7.99988C2 11.3135 4.68625 14 7.99988 14Z"
				fill="#637381"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.52022 9.7152H9.48848V6.80537C9.48848 6.36698 9.13322 6.01172 8.69483 6.01172H4.72656V8.92154C4.72656 9.35993 5.08182 9.7152 5.52022 9.7152ZM10.0173 8.65723L11.6046 9.7152V6.01172L10.0176 7.06992L10.0173 8.65723Z"
				fill="white"
			/>
		</svg>
	);
};
